import {
  IEmployeesService,
  IEmployeesServiceMock,
  IOrderServiceMock,
  IOrdersService,
  ISolCustomerCurrencyService,
  ISolCustomerCurrencyServiceMock,
  SolError,
} from "@/services";

export interface ISolCustomerService {
  getEmployee(
    params: ISolCustomerEmployeeParams
  ): Promise<ISolCustomerEmployeeResponse | undefined>;

  getVehicle(params: ISolCustomerVehicleParams): Promise<ISolCustomerVehicleResponse | undefined>;

  getImage(params: ISolCustomerImageParams): Promise<ISolCustomerImageResponse | undefined>;

  orders: IOrdersService | undefined;
  currency: ISolCustomerCurrencyService | undefined;
  employees: IEmployeesService | undefined;
}

export interface ISolCustomerResponse {
  success: boolean;
  type: string;
  errors?: SolError[];
}

export interface ISolCustomerEmployeeParams {
  countryCode: string;
  language?: string;
  documentTypeCode?: string;
  value?: string;
}

export interface ISolCustomerEmployeeResponse extends ISolCustomerResponse {
  validarDocumento: boolean;
  employees: ISolCustomerEmployee[];
  vehiculo: ISolCustomerEmployeeVehicle;
}

export interface ISolCustomerEmployee {
  name: string;
  lastName: string;
  function: string;
  registry: string;
  workBadge: string;
  photoURL: string;
  signatureURL: string;
  validationDocumentType: string;
  validationDocumentValue: string;
}

export interface ICustomerEmployeeDataToShow {
  id: boolean;
  name: boolean;
  picture: boolean;
  role: boolean;
  sign: boolean;
}

export interface ISolCustomerEmployeeVehicle {
  licensePlate: string;
  number: string;
}

export interface ISolCustomerVehicleParams {
  countryCode: string;
  code?: string;
  plate?: string;
}

export interface ISolCustomerVehicleResponse extends ISolCustomerResponse {
  vehicles: ISolCustomerVehicle[];
}

export interface ISolCustomerVehicle {
  code: string;
  plate: string;
  branch: string;
}

export interface ISolCustomerImageParams {
  country: string;
  p: string;
  type: ISolCustomerImageType;
  token: string;
}

export enum ISolCustomerImageType {
  Person = "P",
  Signature = "F",
}

export interface ISolCustomerImageResponse {
  photo?: string;
  signature?: string;
}

export interface ISolCustomerServiceMock {
  getEmployee: jest.Mock<Promise<ISolCustomerEmployeeResponse | undefined>>;
  getVehicle: jest.Mock<Promise<ISolCustomerVehicleResponse | undefined>>;
  getImage: jest.Mock<Promise<ISolCustomerImageResponse | undefined>>;
  orders: IOrderServiceMock;
  currency: ISolCustomerCurrencyServiceMock;
  employees: IEmployeesServiceMock;
}
